<template>
  <v-container fluid class="fullHeight">
    <v-navigation-drawer right clipped enable-resize-watcher v-model="rightDrawer" fixed app style="overflow-y: hidden;">
      <v-card flat>
        <v-card-media
          height="140"
          :src="'http://adammeraihi.000webhostapp.com/charts/stockage/images/' + curScene + '_mini.jpg'"
        >
        </v-card-media>
      </v-card>
      <v-card flat :height="'calc(100% - 100px)'" style="overflow-y: auto;">
        <v-list dense>
          <v-tooltip left v-for="(item, i) in scenes" :key="i" :disabled="!(formatTitle(item).length > 25)">
            <v-list-tile slot="activator" ripple v-on:click="curScene = item" :value="item === curScene">
              <v-list-tile-action>
                <v-icon>{{ sceneLabel }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ formatTitle(item) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          <span>{{ formatTitle(item) }}</span>
          </v-tooltip>
        </v-list>  
      </v-card>
    </v-navigation-drawer>
    <v-layout row align-end>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer" v-if="needSidebar">
        <v-icon>menu</v-icon>
      </v-btn>
    </v-layout>
    <v-layout column class="fullHeight">
      <v-flex xs12 class="fullHeight">
        <v-tabs
          v-model="tabsValue"
          align-with-title
          color="secundary"
          slider-color="red"
          dark
        >
          <v-tab v-for="(item, i) in tabs" :key="i">
            {{ item.name }}
          </v-tab>
          <v-layout row align-end>
          </v-layout>
          <info :title="info.title" :content="info.content"/>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tabsValue" fixed-tabs class="fullHeight">
          <v-tab-item class="fullHeight" v-for="(item, i) in tabs" :key="i">
            <v-card class="fullHeight">
              <component :is="item.chart" class="fullHeight" v-bind="item.props"/>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import tpsBarChart from './NewCharts/TimePerScene'
import InfoDialog from './Misc/InfoDialog'
const axios = require('axios')

export default {
  data () {
    return {
      currentUser: {},
      admin: false,
      scenes: ['loading_scenes_please_wait'],
      tabs: [
        {
          name: this.$vuetify.t('$vuetify.charts.timePerScene.legend'),
          chart: 'tps-chart',
          props: {},
          sidebar: false
        },
        /*{
          name: this.$vuetify.t('$vuetify.charts.clickedItems.legend'),
          chart: 'clicked-items',
          props: {scene: this.curScene},
          sidebar: true
        },
        {
          name: this.$vuetify.t('$vuetify.charts.heatmap.legend'),
          chart: 'heatmap',
          props: {scene: this.curScene},
          sidebar: true
        }*/
      ],
      curScene: '',
      sceneLabel: 'label',
      rightDrawer: false,
      needSidebar: false,
      tabsValue: null,
      info: {
        title: this.$vuetify.t('$vuetify.info.scenes.title'),
        content: [
          this.$vuetify.t('$vuetify.info.scenes.content.1'),
          this.$vuetify.t('$vuetify.info.scenes.content.2')
        ]
      }
    }
  },
  props: {
    graph: {
      type: Number,
      required: false,
      default: 0
    }
  },
  watch: {
    tabsValue (value) {
      this.$router.replace(this.$route.path + '?graph=' + value)
      if (typeof this.tabs[value] !== 'undefined') {
        setTimeout(() => {
          this.needSidebar = this.rightDrawer = this.tabs[value].sidebar
        }, 500 * this.tabs[value].sidebar)
      }
      var temp = this.curScene
      this.curScene = ''
      setTimeout(() => {
        this.curScene = temp
      }, 1)
    },
    curScene: {
      handler: function (newval) {
        this.tabs[1].props.scene = newval
        this.tabs[2].props.scene = newval
      },
      immediate: true
    }
  },
  mounted () {
    var self = this
    this.tabsValue = this.graph
    axios.get('http://adammeraihi.000webhostapp.com/charts/modeles/SceneList.php')
    .then(function (response) {
      self.scenes = response.data.result
    })
    .catch(function (error) {
      // handle error
      self.scenes[0] = 'Error, could not load scene list'
      console.error(error)
    })
    .then(function () {
      self.curScene = self.scenes[0]
    })
  },
  components: {
    'tps-chart': tpsBarChart,
    //'clicked-items': clickedItemsPerScene,
    'info': InfoDialog,
    //'heatmap': heatmap
  },
  methods: {
    formatTitle (title) {
      return title === null ? '' : title[0].toUpperCase() + title.substring(1).split('_').join(' ')
    }
  },
  name: 'Scenes'
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.fullHeight {
  height : calc(100% - 25px);
}
.tabText {
  text-decoration-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Scenes.vue